import React from "react";
import label from "../../labels/accessRightsManagement_en.json";

const MasterEntry = () => {
  return (
    <div className="dashboardContentArea">
      <h5> {label.MasterEntry} </h5>
      <div className="row dashboardCards"></div>
    </div>
  );
};

export default MasterEntry;
